<template>
    <radio-checkbox-collection 
        :enabled-options="supportedHighlightModes" 
        :options="[{
            value: HIGHLIGHT_MODES.MOST_SUCCESSFUL_ROUTE,
            label: resource('JourneyBuilder_Sankey_HighlightMode_MostSuccessful_Label')
        }, {
            value: HIGHLIGHT_MODES.LEAST_SUCCESSFUL_ROUTE,
            label: resource('JourneyBuilder_Sankey_HighlightMode_LeastSuccessful_Label')
        }, {
            value: HIGHLIGHT_MODES.MOST_TAKEN_ROUTE,
            label: resource('JourneyBuilder_Sankey_HighlightMode_MostTaken_Label')
        }, {
            value: HIGHLIGHT_MODES.LEAST_TAKEN_ROUTE,
            label: resource('JourneyBuilder_Sankey_HighlightMode_LeastTaken_Label')
        }]"
        v-model="valueModel"
    />
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

import HIGHLIGHT_MODES from './highlight-modes';
import resourceMixin from "@core/Util/Mixins/resources";
import RadioCheckboxCollection from "./RadioCheckboxCollection";

const { mapState, mapGetters, mapMutations } = createNamespacedHelpers('journeyBuilder/reporting');

export default {
    name: "HighlightModeSelector",
    
    components: {
        RadioCheckboxCollection
    },
    
    mixins: [resourceMixin],

    data() {
        return {
            HIGHLIGHT_MODES
        }
    },
    
    computed: {
        ...mapState(['highlightMode']),
        ...mapGetters(['supportedHighlightModes']),
        valueModel: {
            set(value) {
                this.setHighlightMode(value);
            },
            get() {
                return this.highlightMode;
            }
        }
    },

    watch: {
        supportedHighlightModes(value){
            //Prevent selecting an invalid highlight mode
            if(!value.includes(this.valueModel)){
                this.valueModel = undefined;
            }
        }
    },
    
    methods: {
        ...mapMutations(['setHighlightMode'])
    }
}
</script>
